import React from 'react';
import PropTypes from 'prop-types';
import {
  Icon,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  CircularProgress,
} from '@mui/material';

export class HistoryActionsMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      element: null,
    };
  }

  handleOpen = (e) => {
    this.setState({
      open: true,
      element: e.currentTarget,
    });
  }

  handleClose = () => {
    this.setState({
      open: false,
      element: null,
    });
  }

  handleActionClick = (action) => {
    action();
    this.handleClose();
  }

  render() {
    const {
      isLoading,
      onEdit,
      onDelete,
    } = this.props;
    return (
      <div>
        {
          isLoading
            ? <CircularProgress size={30} />
            : (
              <IconButton
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleOpen(e); }}
                id="menu-btn"
                aria-owns={this.state.open
                  ? 'menu-appbar'
                  : null}
                aria-haspopup="true"
              >
                <Icon>more_vert</Icon>
              </IconButton>
            )
        }
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: 0,
            left: 0,
          }}
          open={this.state.open}
          onClose={this.handleClose}
        >
          {
            onEdit
            && (
              <MenuItem onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleActionClick(onEdit); }}>
                <ListItemIcon>
                  <Icon>edit</Icon>
                </ListItemIcon>
                Edit
              </MenuItem>
            )
          }
          {
            onDelete
            && (
              <MenuItem onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.handleActionClick(onDelete); }}>
                <ListItemIcon>
                  <Icon>delete</Icon>
                </ListItemIcon>
                Delete
              </MenuItem>
            )
          }
        </Menu>
      </div>
    );
  }
}

HistoryActionsMenuComponent.propTypes = {
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

HistoryActionsMenuComponent.defaultProps = {
  isLoading: false,
  onEdit: undefined,
  onDelete: undefined,
};

export default HistoryActionsMenuComponent;
